<template>
  <b-modal
    :title="'Type'"
    v-model="modalShow"
    size="lg"
    @hide.prevent="handleHide"
    @cancel="handleCancel"
    @close="handleCancel"
    @ok="handleOk"
  >
    <div class="container">
      <div class="row align-items-center">
        <label class="col-3">
          <span class="required-mark">TypeName</span>
        </label>
        <div class="col-9">
          <b-form-input :required="true" v-model.lazy="newTypeTitle" type="text" />
        </div>
      </div>

      <div class="row align-items-center">
        <label class="col-3">
          <span class="required-mark">Mnemonic</span>
        </label>
        <div class="col-9">
          <b-form-input :required="true" v-model.lazy="mnemonicTitle" type="text" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "vis-type-create-view",
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      modalShow: this.visible,
      isValid: true,
      newMnemonicName: null,
      newTypeTitle: null,
      mnemonicTitle: null
    };
  },
  watch: {
    visible(nv) {
      this.modalShow = nv;
    }
  },
  methods: {
    handleCancel() {
      this.isValid = true;
      this.$emit("hide");
    },
    handleOk(e) {
      if (
        this.newTypeTitle === null ||
        this.newTypeTitle === "" ||
        this.mnemonicTitle === null ||
        this.mnemonicTitle === ""
      ) {
        e.preventDefault();
        this.isValid = false;
      } else {
        this.isValid = true;
        this.$emit("ok", {
          TypeTitle: this.newTypeTitle,
          MnemonicTitle: this.mnemonicTitle
        });
      }
    },
    handleHide() {
      this.$emit("hide", this.isValid);
    }
  }
};
</script>
